import { Page } from '@/types'
import { AxiosInstance } from 'axios'
import axiosInstance from '.'

export interface HeaderRequest {
  line1: string
  line2: string
  line3: string
}

export interface HeaderDto {
  id: number

  line1: string
  line2: string
  line3: string

  createdTime: string
  updatedTime:string
}

class HeaderApi {
  private axios: AxiosInstance

  public constructor(axios: AxiosInstance) {
    this.axios = axios
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async getAllHeaders(params: any): Promise<Page<HeaderDto>> {
    const axiosResponse = await this.axios.get('/header', { params })
    return axiosResponse.data
  }

  public create(request: HeaderRequest): Promise<HeaderDto> {
    return this.axios.post('/header', request).then(el => el.data)
  }

  public update(id: number, request: HeaderRequest) {
    return this.axios.put(`/header/${id}`, request)
  }
}

export const headerApi = new HeaderApi(axiosInstance)
